module.exports = __webpack_public_path__ + "static/img/logo64.baa2678.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo64.png
// module id = Eat9
// module chunks = 1